// スクロールスコープ（プラグイン管理）
import commonClass from "./commonClass";

export default class scrollScopeClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    $(document).scrollScope();
  }

}